<template>
    <div class="w-full h-full">
        <div class="h-full w-full flex">
            <div v-if="loadBoutique && boutiques.length == 0" class="w-full h-full flex items-center justify-center">
                <div class="mx-auto">
                    <div class="w-auto flex justify-center">
                        <svg class="h-[9rem]" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" version="1.1">
                            <g id="surface1">
                                <path style=" stroke:none;fill-rule:nonzero;fill:#666666;fill-opacity:1;"
                                    d="M 56 4 C 50.40625 4 45.59375 7.609375 44.390625 13.203125 L 4.40625 173.203125 C 4 174 4 175.203125 4 176 C 4 209.203125 30.796875 236 64 236 C 83.59375 236 101.203125 226.40625 112 212 C 122.796875 226.796875 140.40625 236 160 236 C 179.59375 236 197.203125 226.40625 208 212 C 218.796875 226.796875 236.40625 236 256 236 C 275.59375 236 293.203125 226.40625 304 212 C 314.796875 226.40625 332.40625 236 352 236 C 371.59375 236 389.203125 226.40625 400 212 C 410.40625 225.59375 426 234.796875 444 235.609375 L 444 436 L 220 436 L 220 272 C 220 265.203125 214.796875 260 208 260 C 201.203125 260 196 265.203125 196 272 L 196 484 L 68 484 L 68 272 C 68 265.203125 62.796875 260 56 260 C 49.203125 260 44 265.203125 44 272 L 44 484 L 16 484 C 9.203125 484 4 489.203125 4 496 C 4 502.796875 9.203125 508 16 508 L 496 508 C 502.796875 508 508 502.796875 508 496 C 508 489.203125 502.796875 484 496 484 L 468 484 L 468 232.390625 C 491.203125 224 508 202 508 176 C 508 175.203125 508 174 507.59375 173.203125 L 467.59375 13.203125 C 466.40625 7.609375 461.59375 4 456 4 Z M 142.390625 28 L 199.609375 28 L 196 176 C 196 196 180 212 160 212 C 140.40625 212 124.40625 196 124 176.390625 Z M 312.390625 28 L 369.609375 28 L 388 176.796875 C 387.59375 196.390625 371.59375 212 352 212 C 332.40625 212 316.40625 196 316 176 L 316 175.609375 Z M 352.171875 276.109375 C 347.484375 276 342.890625 278.703125 340.796875 283.203125 L 292.796875 391.203125 C 290 397.203125 292.796875 404.40625 298.796875 407.203125 C 300.390625 408 302 408.40625 303.609375 408.40625 C 308 408.40625 312.390625 405.609375 314.390625 401.203125 L 362.390625 293.203125 C 365.59375 286.796875 362.796875 279.609375 356.796875 277.203125 C 355.296875 276.5 353.734375 276.140625 352.171875 276.109375 Z M 395.765625 295.3125 C 391.078125 295.203125 386.5 297.890625 384.390625 302.390625 L 360.390625 356.390625 C 358.390625 362.796875 360.796875 369.59375 366.796875 372.390625 C 368.390625 373.203125 370 373.609375 371.609375 373.609375 C 376 373.609375 380.390625 370.796875 382.390625 366.390625 L 406.40625 312.390625 C 409.203125 306.390625 406.40625 299.203125 400.40625 296.390625 C 398.890625 295.703125 397.328125 295.34375 395.765625 295.3125 Z M 168 368 C 161.375 368 156 373.375 156 380 C 156 386.625 161.375 392 168 392 C 174.625 392 180 386.625 180 380 C 180 373.375 174.625 368 168 368 Z " />
                            </g>
                        </svg>
                    </div>
                    <div class="w-auto flex justify-center">
                        <p class="text-center text-[#6B6B6B]">{{ $t('aucunboutiquetrouve') }}</p>
                    </div>
                </div>
            </div>
            <div v-if="loadBoutique && boutiques.length > 0" id="scrollBoutique" @scroll="loadInfinite"
                class=" overflow-y-auto mx-auto h-full w-full">
                <div class="w-full mx-auto p-2">
                    <div
                        class="grid gap-2 grid-cols-[repeat(auto-fill,minmax(8rem,1fr))] md:grid-cols-[repeat(auto-fill,minmax(16rem,1fr))]">
                        <div v-for="boutique in boutiques.filter(item => item.id != user.id)" :key="boutique.id"
                            class="h-64 rounded-xl bg-white p-3 shadow-lg hover:shadow-xl hover:transform hover:scale-105 duration-1000">
                            <div>
                                <div :class="boutique.avatar ? '' : 'bg-black'"
                                    class="relative flex items-end overflow-hidden rounded-xl">
                                    <img v-if="boutique.avatar" class="h-32 object-cover w-full" :src="boutique.avatar"
                                        alt="Hotel Photo" />
                                    <div v-if="boutique.avatar == '' || boutique.avatar == null"
                                        class="h-32 w-full flex justify-center">
                                        <img class="h-[90%] object-cover" src="/logo/mel_logo_blanc.png"
                                            alt="logo mel" />
                                    </div>
                                    <div
                                        class="absolute bottom-3 left-3 inline-flex items-center rounded-lg bg-white p-2 shadow-md">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-yellow-400"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path
                                                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                        </svg>
                                        <span v-if="boutique.avis > 0" class="ml-1 text-sm text-slate-400">{{
                                            Math.round(boutique.etoile / boutique.avis) }}</span>
                                        <span v-if="boutique.avis == 0" class="ml-1 text-sm text-slate-400">0</span>
                                    </div>
                                </div>

                                <div class="mt-1 p-2">
                                    <div class="flex space-x-1">
                                        <div class="h-auto flex items-center">
                                            <h2 class="text-slate-700 font-bold ">{{ boutique.name }}</h2>
                                        </div>
                                        <div class="h-auto flex items-center">
                                            <img v-if="boutique.type != 0"
                                                class="w-5 h-5 mx-auto object-cover object-center rounded-full "
                                                src="/icons/approval2.png" alt="" srcset="">
                                        </div>
                                    </div>
                                    <p class="mt-1 text-sm text-slate-400">{{ boutique.ville }}, {{ boutique.mon_pays }}
                                    </p>
                                    <div class="mt-3 flex items-end justify-between">
                                        <div class="h-auto text-lg font-bold flex items-center space-x-2">
                                            <img class="w-6 h-6" src="/icons/group.png" alt="" srcset="">
                                            <p>{{ boutique.nbr_suiveur }}</p>
                                        </div>
                                        <button @click="viewProfil(boutique)"
                                            class="flex cursor-pointer items-center space-x-1.5 rounded-lg group bg-[#FF9900] px-4 py-1.5 text-white  hover:bg-transparent hover:border-[1px] hover:text-[#FF9900] hover:border-[#FF9900] transition-all duration-1000">
                                            <svg class="w-4 h-4 fill-white group-hover:fill-[#FF9900] transition-all duration-1000"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="512pt" height="512pt"
                                                viewBox="0 0 512 512" version="1.1">
                                                <g id="surface1">
                                                    <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                                                        d="M 56 4 C 50.40625 4 45.59375 7.609375 44.390625 13.203125 L 4.40625 173.203125 C 4 174 4 175.203125 4 176 C 4 209.203125 30.796875 236 64 236 C 83.59375 236 101.203125 226.40625 112 212 C 122.796875 226.796875 140.40625 236 160 236 C 179.59375 236 197.203125 226.40625 208 212 C 218.796875 226.796875 236.40625 236 256 236 C 275.59375 236 293.203125 226.40625 304 212 C 314.796875 226.40625 332.40625 236 352 236 C 371.59375 236 389.203125 226.40625 400 212 C 410.40625 225.59375 426 234.796875 444 235.609375 L 444 436 L 220 436 L 220 272 C 220 265.203125 214.796875 260 208 260 C 201.203125 260 196 265.203125 196 272 L 196 484 L 68 484 L 68 272 C 68 265.203125 62.796875 260 56 260 C 49.203125 260 44 265.203125 44 272 L 44 484 L 16 484 C 9.203125 484 4 489.203125 4 496 C 4 502.796875 9.203125 508 16 508 L 496 508 C 502.796875 508 508 502.796875 508 496 C 508 489.203125 502.796875 484 496 484 L 468 484 L 468 232.390625 C 491.203125 224 508 202 508 176 C 508 175.203125 508 174 507.59375 173.203125 L 467.59375 13.203125 C 466.40625 7.609375 461.59375 4 456 4 Z M 142.390625 28 L 199.609375 28 L 196 176 C 196 196 180 212 160 212 C 140.40625 212 124.40625 196 124 176.390625 Z M 312.390625 28 L 369.609375 28 L 388 176.796875 C 387.59375 196.390625 371.59375 212 352 212 C 332.40625 212 316.40625 196 316 176 L 316 175.609375 Z M 352.171875 276.109375 C 347.484375 276 342.890625 278.703125 340.796875 283.203125 L 292.796875 391.203125 C 290 397.203125 292.796875 404.40625 298.796875 407.203125 C 300.390625 408 302 408.40625 303.609375 408.40625 C 308 408.40625 312.390625 405.609375 314.390625 401.203125 L 362.390625 293.203125 C 365.59375 286.796875 362.796875 279.609375 356.796875 277.203125 C 355.296875 276.5 353.734375 276.140625 352.171875 276.109375 Z M 395.765625 295.3125 C 391.078125 295.203125 386.5 297.890625 384.390625 302.390625 L 360.390625 356.390625 C 358.390625 362.796875 360.796875 369.59375 366.796875 372.390625 C 368.390625 373.203125 370 373.609375 371.609375 373.609375 C 376 373.609375 380.390625 370.796875 382.390625 366.390625 L 406.40625 312.390625 C 409.203125 306.390625 406.40625 299.203125 400.40625 296.390625 C 398.890625 295.703125 397.328125 295.34375 395.765625 295.3125 Z M 168 368 C 161.375 368 156 373.375 156 380 C 156 386.625 161.375 392 168 392 C 174.625 392 180 386.625 180 380 C 180 373.375 174.625 368 168 368 Z " />
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="fin == false && scrollExec" class="w-full flex items-center">
                        <div class="chaotic-orbit mx-auto"></div>
                    </div>
                    <div class="w-full flex mt-1 text-gray-500" v-if="fin">
                        <p class="mx-auto" v-if="langue == 'fr'">Plus aucun boutiques !</p>
                        <p class="mx-auto" v-if="langue == 'en'">No more shops !</p>
                    </div>
                </div>
            </div>
            <div v-if="loadBoutique == false"
                class="mx-auto h-full w-full overflow-hidden grid gap-2 grid-cols-[repeat(auto-fill,minmax(8rem,1fr))] md:grid-cols-[repeat(auto-fill,minmax(16rem,1fr))] p-2">
                <div v-for="i in 20" :key="i.id"
                    class="rounded-xl h-64 bg-white p-3 shadow-lg hover:shadow-xl hover:transform hover:scale-105 duration-1000">
                    <a href="w-full h-full">
                        <div
                            class="relative w-[100%] h-[60%] flex items-end overflow-hidden rounded-xl bg-gray-300 animate-pulse">
                            <div
                                class="absolute bottom-3 left-3 inline-flex items-center rounded-lg bg-white p-2 shadow-md">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 fill-gray-300 animate-pulse"
                                    viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                </svg>
                                <span class="w-3 h-2 bg-gray-300 animate-pulse"></span>
                            </div>
                        </div>

                        <div class="mt-1 p-2">
                            <div class="flex space-x-1">
                                <div class="h-auto flex items-center">
                                    <h2 class=" font-bold w-16 h-2 bg-gray-300 animate-pulse"></h2>
                                </div>
                            </div>
                            <div class="w-32 h-2 bg-gray-300 animate-pulse mt-2"></div>
                            <div class="mt-3 flex items-end justify-between">
                                <div
                                    class="w-16 h-5 text-lg font-bold flex items-center space-x-2 bg-gray-300 animate-pulse">
                                </div>
                                <div
                                    class="flex items-center rounded-lg w-10 md:w-20 h-8 px-4 py-1.5  bg-gray-300 animate-pulse">
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    beforeRouteLeave() {
        window.emitter.off("searchElementBoutique")
    },
    data() {
        return {
            page: 1,
            pageSearch: 1,
            boutiques: [],
            user: '',
            loadBoutique: false,
            scrollExec: false,
            fin: false,
        }
    },
    created() {
        window.emitter.on("searchElementBoutique", (mot) => {
            if (mot.value.length > 0) {
                this.pageSearch = mot.page
                this.loadBoutique = false
                this.searchBoutique(mot.value)
                console.log('hey')
            } else {
                this.boutiques = this.$store.state.boutiques
                this.pageSearch = 1
                this.loadBoutique = true
            }
        })
    },
    mounted() {
        this.requestAuth == 'NotAuth' ? this.$router.push('/') : ''
        this.langue = localStorage.getItem('langue');
        this.user = this.$store.state.dataAccueil[0]
        if (this.user.sexe == null && this.user.ville == null && this.user.description == null && this.user.date_naissance == null) {
            this.$router.push('/profil');
        }
        this.$store.state.preview = ''
        if (this.$store.state.boutiques.length > 0) {
            this.boutiques = this.$store.state.boutiques
            this.page = Math.ceil(this.$store.state.boutiques.length / 20) + 1
            this.loadBoutique = true
        } else {
            this.axios.get(this.requestHttp + 'allboutiques' + '?page=' + this.page, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                },
            }).then(({ data }) => {
                if (data[0].data.length == 1) {
                    data[0].data.filter((item, index) => item.id == this.$store.state.dataAccueil[0].id ? this.boutiques.splice(index, 1) : (this.$store.boutiques = [], this.$store.state.boutiques = []))
                } else {
                    this.boutiques = data[0].data
                    this.$store.state.boutiques = data[0].data
                    this.page += 1
                    this.loadBoutique = true
                }
            }).catch()
        }

        this.$nextTick(() => {
            if (document.getElementById('scrollBoutique')) {
                document.getElementById('scrollBoutique').scrollTop = this.$store.state.routerLastPosition['scrollAllBoutique']
            }
        })
    },
    methods: {
        viewProfil(profil) {
            if (profil.id == this.user.id) {
                this.$router.push('infoprofil')
            } else {
                this.$store.dispatch('requestViewProfil', profil)
                this.$router.push({name:'viewprofil', query:{id:this.$crypto(profil.id), name: profil.name} })
            }
        },
        searchBoutique(value) {
            this.axios.get(this.requestHttp + 'search_boutique', {
                params: {
                    mot: value,
                    page: this.pageSearch,
                },
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                },
            }).then(({ data }) => {
                this.boutiques = data[0].data
                this.pageSearch += 1
                this.loadBoutique = true
            })
                .catch()
        },
        infiniteHandler() {
            this.axios.get(this.requestHttp + 'allboutiques' + '?page=' + this.page, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                },
            }).then(({ data }) => {
                if (data[0].data.length > 0) {
                    this.boutiques.push(...data[0].data)
                    this.page += 1
                    this.scrollExec = false
                } else {
                    this.fin = true
                }
            })
                .catch()
        },
        loadInfinite(e) {
            const max = e.target.scrollHeight //la partie que la bar de scroll doit parcourir + la hauteur de la bar de scroll
            const base = e.target.clientHeight //la hauteur de la bar de scroll
            const scrollY = e.target.scrollTop //la distance parcouru par la bar du scroll
            const delta = max - (base + scrollY)
            this.$store.dispatch('requestRouterLastPosition', { name: 'scrollAllBoutique', scrollPosition: e.target.scrollTop })
            //console.log(max, max * 40/100, delta,base,scrollY);
            if (delta <= max * 40 / 100 && this.scrollExec == false) {
                this.scrollExec = true
                this.infiniteHandler()
            }
        },
    },
    computed: {
        requestAuth() {
            return this.$store.state.auth
        },
        requestHttp() {
            return this.$store.state.api
        },
        requestFile() {
            return this.$store.state.apifile
        },


    }
}
</script>

<style></style>